import { render, staticRenderFns } from "./InputSize.vue?vue&type=template&id=7873c08c"
import script from "./InputSize.vue?vue&type=script&lang=js"
export * from "./InputSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports